import { useMemberGetQuery, useMemberMutate } from "modules/members/api";
import { MFMemberAccount } from "./member";
import { wroteAccounts } from "./offboardingWrites";

export type MFOffboardingAccount = {
  id: string;
  status: "incomplete" | "complete" | "declined";
  offboardingStatus: "not_ready" | "started" | "complete";
  dueDate: string;
  declinedReason: string | null;
  accountRemovedAt: string | null;
  oauthTokensRevokedAt: string | null;
  adminRightsConfirmedAt: string | null;
  adminRightsAssigneeId: string | null;
  assigneeId: string | null;
  loginBlockedAt: string | null;
  memberAccountId: string;
  memberAccount: MFMemberAccount;
  offboardingId: string;
};

const useListOffboardings = (): MFOffboardingAccount[] => {
  const data = useMemberGetQuery<MFOffboardingAccount[]>(
    ["mf", "offboardings"],
    "/members/offboarding",
  );
  return data.data || [];
};

export type MFUpdateOffboardingAccountsParams = {
  accountIds: string[];
  declinedReason?: string;
  markRemoved?: boolean;
  markLoginBlocked?: boolean;
  markDeclined?: boolean;
  markTransferred?: boolean;
  adminRightsAssignedToId?: string;
  adminTransferNotRequired?: boolean;
};

// Resolves to whether every account asked for was written.
const useUpdateOffboardingAccounts = (offboardingId: string) => {
  const { mutate, isLoading } = useMemberMutate<{ id: string }[]>(
    "POST",
    `/members/offboarding/${offboardingId}/accounts`,
    [["mf", "offboardings"]],
  );
  return {
    isLoading,
    mutate: (params: MFUpdateOffboardingAccountsParams) =>
      mutate({
        account_ids: params.accountIds,
        mark_removed: params.markRemoved,
        mark_login_blocked: params.markLoginBlocked,
        mark_admin_rights_transferred: params.markTransferred,
        admin_transfer_not_required: params.adminTransferNotRequired,
        admin_assigned_to_id: params.adminRightsAssignedToId,
        declined_reason: params.declinedReason,
        mark_declined: params.markDeclined,
      }).then(
        (res) => res.success && wroteAccounts(res.data, params.accountIds),
      ),
  };
};

export const MF_OFFBOARDING = {
  useListOffboardings,
  useUpdateOffboardingAccounts,
};
